import logoNuevo from 'assets/img/favicon.png'
import Menu from 'components/layout/Menu/Menu'
import PropTypes from 'prop-types'
import { LuPanelLeftClose, LuPanelLeftOpen } from 'react-icons/lu'

export default function Sidebar({ isSidebarOpen, setIsSidebarOpen }) {
  return (
    <>
      {/* Barra lateral para dispositivos con pantallas mayores a 768px (tablets grandes, portátiles, pantallas grandes) */}
      <aside
        id="sidebar"
        className={`fixed top-0 left-0 z-20 h-screen font-normal bg-base dark:bg-[#1F2023] transition-width duration-100 ${isSidebarOpen ? 'hidden md:flex md:flex-col md:flex-shrink-0 w-0 md:w-60' : 'hidden md:flex md:flex-col md:flex-shrink-0 w-0 md:w-20'}`}
        aria-label="Sidebar"
      >
        <div className="relative flex flex-col flex-1 min-h-0">
          <div
            className={`px-2.5 py-4 flex justify-between ${isSidebarOpen ? 'flex-row items-center' : 'flex-col items-start space-y-5'}`}
          >
            <div
              title="Claim Sphere"
              className={`inline-flex pl-1 text-base text-white duration-75`}
            >
              <img
                className={`block float-left duration-500 rounded-full w-12 object-contain h-12 min-w-12 max-w-12 p-0.5 ${isSidebarOpen && 'rotate-[360deg]'}`}
                src={logoNuevo}
                alt=""
              />
            </div>

            {!isSidebarOpen ? (
              <div className="w-full pl-3.5">
                <LuPanelLeftOpen
                  title="Expandir menú"
                  className={`text-white cursor-pointer hover:text-accent duration-300`}
                  size={26}
                  onClick={() => setIsSidebarOpen((prev) => !prev)}
                />
              </div>
            ) : (
              <div className="w-auto">
                <LuPanelLeftClose
                  title="Contraer menú"
                  className={`text-white cursor-pointer hover:text-accent duration-300`}
                  size={26}
                  onClick={() => setIsSidebarOpen((prev) => !prev)}
                />
              </div>
            )}
          </div>

          <ul
            id="scrollable-sidebar"
            className="pl-1.5 pr-2 py-3 space-y-2 overflow-y-scroll overflow-x-hidden grow border-t-2 border-dashed border-accent font-medium"
          >
            <Menu isSidebarOpen={isSidebarOpen} />
          </ul>
        </div>
      </aside>

      {/* Barra lateral para dispositivos con pantallas menores a 768px (móviles, tablets pequeñas) */}
      <aside
        id="sidebar"
        className={`fixed top-0 left-0 z-20 h-screen flex flex-col flex-shrink-0 font-normal bg-base dark:bg-[#38393D] transition-width duration-100 ${isSidebarOpen ? 'md:hidden w-9/12 sm:w-6/12 md:w-60' : 'w-0 overflow-hidden'}`}
        aria-label="Sidebar"
      >
        <div className="relative flex flex-col flex-1 min-h-0 px-3 py-4">
          <div
            className={`flex items-center justify-between duration-300 ${isSidebarOpen ? 'flex-row-reverse' : 'flex-col space-y-8 pt-2.5'}`}
          >
            {!isSidebarOpen ? (
              <LuPanelLeftOpen
                className={`text-white cursor-pointer hover:text-accent`}
                size={30}
                onClick={() => setIsSidebarOpen((prev) => !prev)}
              />
            ) : (
              <LuPanelLeftClose
                className={`text-white cursor-pointer hover:text-accent`}
                size={30}
                onClick={() => setIsSidebarOpen((prev) => !prev)}
              />
            )}

            <div className={`inline-flex pl-1 text-base text-white`}>
              <img
                className={`block float-left duration-500 rounded-full w-12 p-1`}
                src={logoNuevo}
                loading="lazy"
                alt="Gestinet"
              />
            </div>
          </div>

          <ul
            id="scrollable-sidebar"
            className="pt-4 pl-0.5 space-y-2 overflow-x-hidden overflow-y-scroll grow font-medium"
          >
            <Menu
              isSidebarOpen={isSidebarOpen}
              setIsSidebarOpen={setIsSidebarOpen}
            />
          </ul>
        </div>
      </aside>

      {/* Fondo oscuro para dispositivos con pantallas menores a 768px al abrir la barra lateral (móviles, tablets pequeñas) */}
      <div
        className={`${isSidebarOpen ? 'md:hidden' : 'hidden'} duration-1000 fixed z-10 w-screen h-screen bg-black bg-opacity-60`}
        onClick={() => {
          if (setIsSidebarOpen) {
            setIsSidebarOpen(false)
          }
        }}
      ></div>
    </>
  )
}

Sidebar.propTypes = {
  isSidebarOpen: PropTypes.bool,
  setIsSidebarOpen: PropTypes.func
}
